import { OpenDuty, PlannedDuty } from './types';

import { OpenRequestDutyIcons } from './OpenRequestDuty/OpenRequestDuty';
import { hasIcons as hasOpenRequestIcons } from './OpenRequestDuty/OpenRequestDuty.utils';
import { Icon } from '@sdb/planning-ui';

export default function DutyIcons(duty: PlannedDuty | OpenDuty) {
  const { notes = [], qualifications } = duty;
  const validNotes = notes.filter(({ text }) => text?.trim());
  const hasNotes = Boolean(validNotes.length);
  const hasQualifications = Boolean(qualifications && qualifications.length);
  const isOpenRequestAndHasIcons = Boolean(
    duty.isOpen && hasOpenRequestIcons(duty)
  );
  const hasIcons = hasNotes || hasQualifications || isOpenRequestAndHasIcons;

  if (hasIcons) {
    return (
      <div className="icons">
        {hasNotes && <Icon type="comment" fontSize="small" />}
        {duty.isOpen && isOpenRequestAndHasIcons && (
          <OpenRequestDutyIcons {...duty} />
        )}
        {hasQualifications && <Icon type="file-certificate" fontSize="small" />}
      </div>
    );
  }

  return <></>;
}
